"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDSTooltip = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var BDSTooltip = function (props) {
    var _a = props.placement, placement = _a === void 0 ? 'top' : _a;
    var StyledTooltip = styles_1.withStyles(function () { return ({
        tooltip: {
            backgroundColor: '#2a2e37',
            borderRadius: '4px',
            color: '#fff',
            padding: '8px',
            fontSize: 12,
            margin: '8px',
        },
    }); })(core_1.Tooltip);
    return jsx_runtime_1.jsx(StyledTooltip, tslib_1.__assign({}, props, { placement: placement }), void 0);
};
exports.BDSTooltip = BDSTooltip;
